export default function (state, {Code}) {
    let item = state.PaymentDetails.filter(i => {
        return i.Code === Code;
    })[0];
    state.PaymentDetails.splice(state.PaymentDetails.indexOf(item), 1);
}